import React, { FC } from "react";
import { useModuleMetadataFromId } from "../../../../../../../store/modules/useSelectors";
import ModuleDropdown, { ModuleDropDownProps } from "./ModuleDropdown";

export type ContainerProps = Omit<
  ModuleDropDownProps,
  "moduleIcon" | "moduleName"
>;

const Container: FC<ContainerProps> = ({ moduleId, closeNav }) => {
  const { image = "", name = "" } = useModuleMetadataFromId(moduleId) || {};

  return (
    <ModuleDropdown
      moduleId={moduleId}
      moduleIcon={image}
      moduleName={name}
      closeNav={closeNav}
    />
  );
};

export default Container;
